require("!!/home/hellomojito/agency-space/node_modules/script-loader/addScript.js")(require("!!/home/hellomojito/agency-space/node_modules/raw-loader/index.js!/home/hellomojito/agency-space/assets/plugins/jquery-bez/jquery.bez.min.js"))


//////////////////
// WEBPACK FOOTER
// ./assets/plugins/jquery-bez/jquery.bez.min.js
// module id = 708
// module chunks = 0